export default __webpack_public_path__ + "./fonts/down-arrow.0e34b00f008e9c92b4bd0aafca6997f8.svg";